import { FC } from "react";
import { Skeleton } from "../../../components/loading";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import Typography from "@mui/material/Typography";

interface Props {
  isLoading: boolean;
  attributeName: string;
  attributeDescription?: string;
}

const AttributeSummaryCard: FC<Props> = (props) => {
  return (
    <OutlinedPaper id="product-attribute-summary" sx={{ p: 3 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <Skeleton isLoading={props.isLoading}>
          <div>
            <Typography variant="h3">{props.attributeName}</Typography>
          </div>
          {props.attributeDescription && (
            <div>
              <Typography>{props.attributeDescription}</Typography>
            </div>
          )}
        </Skeleton>
      </div>
    </OutlinedPaper>
  );
};

export default AttributeSummaryCard;
